export { default } from './ProfileStats';
